var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-16 px-4 overflow-hidden"},[_c('post-login-registration-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }